'use strict';

var polyglot = require('../utilities/polyglot').default;

var StepsCollection = require('./steps').default;

export default StepsCollection.extend({

  initialize: function () {
    this.setupSteps();

    StepsCollection.prototype.initialize.call(this);
  },

  setupSteps: function () {
    this.add([
      {
        slug: polyglot.t('pages.details.slug'),
        short_title: polyglot.t('pages.details.short_title'),
        long_title: polyglot.t('pages.details.long_title'),
      },
    ]);

    if (window.SETTINGS.enable_payment && window.SETTINGS.credit_card_capture) {
      this.add({
        slug: polyglot.t('pages.payment.slug'),
        short_title: polyglot.t('pages.payment.short_title'),
        long_title: polyglot.t('pages.payment.long_title'),
      });
    }
  },
});
